import InvestimentosACadastrarService from "../../../services/http/services/SaldoDeContas/InvestimentosACadastrarService";

export const getQuantidadesInvestimentosACadastrarSaldoDeContas = async () => {
    try {
        const response = await InvestimentosACadastrarService.getQuantidadeInvestimentosACadastrar();
        return response;
    } catch (error: any) {
        return null;
    }
};
